export enum GameLayer {
    Base,
    Border,
    Overlay,
};

export const LAYERS: GameLayer[] = Object.values(GameLayer).filter(x => typeof x === 'number') as GameLayer[];